import SingleValueCode from "!!raw-loader!./sliders/SingleValue.tsx";
import RangeValueCode from "!!raw-loader!./sliders/RangeValue.tsx";
import FormLabelCode from "!!raw-loader!./sliders/FormControlLabel.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import SingleValue from "./sliders/SingleValue";
import RangeValue from "./sliders/RangeValue";
import FormControlLabel from "./sliders/FormControlLabel";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Single Value", SingleValueCode, SingleValue),
		paneComponent("Range Value", RangeValueCode, RangeValue),
		paneComponent("Form Control Label", FormLabelCode, FormControlLabel),
	];

	return (
		<Pane
			components={components}
			imports='import {Slider} from "designSystem/index";'
			muiApi="slider"
			muiComponent="sliders"
			{...props}
		/>
	);
};